import actionTypes from '../actions/reduxActions/actionTypes';
import { assocPath, merge } from 'ramda';
import moment from 'moment';

const initialState = {
    data: [],
    filterDate: moment().utc().toDate(),
    filterTypes: [],
    filterUsers: [],
    isLoading: true,
    page: 1,
    pageSize: 15,
};

const logs = (auditLogs = initialState, { type, payload, error, meta }) => {
    switch (type) {
    case actionTypes.LOGS_SET:
        return merge(auditLogs, { data: payload, isLoading: false });
    case actionTypes.LOGS_SET_LOADER:
        return assocPath(['isLoading'], payload.isLoading, auditLogs);
    case actionTypes.LOGS_RESET_FILTERS:
        return initialState;
    case actionTypes.LOGS_SET_DATE_FILTER:
        return assocPath(['filterDate'], payload.date, auditLogs);
    case actionTypes.LOGS_SET_USER_FILTER:
        return assocPath(['filterUsers'], payload.users, auditLogs);
    case actionTypes.LOGS_SET_LOG_TYPE_FILTER:
        return assocPath(['filterTypes'], payload.logTypes, auditLogs);
    case actionTypes.LOGS_SET_PAGE:
        return assocPath(['page'], payload.pageNumber, auditLogs);
    default:
        return auditLogs;
    }
};

export default logs;
